import { render, staticRenderFns } from "./ScaniaNextGenBodyworkSymbols.vue?vue&type=template&id=91df28c8&"
import script from "./ScaniaNextGenBodyworkSymbols.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenBodyworkSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports